// extracted by mini-css-extract-plugin
export default {"selectorFooter":"EditTypeModal_selectorFooter__nFTWU","placeHolderShimmer":"EditTypeModal_placeHolderShimmer__h0CMe"};